import type { Staff } from "@senciamatch/shared/models/staff";
import { newStaff } from "@senciamatch/shared/models/staff";

// CSV format
const CSV_FORMAT = [
  "ｽﾀｯﾌ番号", // 0
  "氏名(漢字)", // 1
  "氏名(ｶﾅ)", // 2
  "性別", // 3
  "郵便番号", // 4
  "住所1", // 5
  "住所2", // 6
  "住所3", // 7
  "最寄駅", // 8
  "健康保険加入状況", // 9
  "退職", // 10
];

export interface StaffStatus {
  [staffId: string]: "new" | "edited" | "persisted";
}

const rowStatus = (rowStaff: Staff, existingStaffs: Staff[]): StaffStatus => {
  const existingStaff = existingStaffs.find((staff) => staff.id === rowStaff.id);

  if (!existingStaff) return { [rowStaff.id]: "new" };

  if (existingStaff.name !== rowStaff.name) return { [rowStaff.id]: "edited" };
  if (existingStaff.nameKana !== rowStaff.nameKana) return { [rowStaff.id]: "edited" };
  if (existingStaff.postalCode !== rowStaff.postalCode) return { [rowStaff.id]: "edited" };
  if (existingStaff.address !== rowStaff.address) return { [rowStaff.id]: "edited" };
  if (existingStaff.isSocialInsurance !== rowStaff.isSocialInsurance) return { [rowStaff.id]: "edited" };
  if (existingStaff.nearestStation !== rowStaff.nearestStation) return { [rowStaff.id]: "edited" };
  if (existingStaff.isActive !== rowStaff.isActive) return { [rowStaff.id]: "edited" };

  return { [rowStaff.id]: "persisted" };
};

const validateCSV = (data: string[][]) => {
  const title = data[0];

  if (title.length !== CSV_FORMAT.length) return false;

  return true;
};

const parse = async (data: string[][], existingStaffs: Staff[]): Promise<{ staffs: Staff[]; status: StaffStatus }> => {
  const status: StaffStatus = {};

  const staffs = data
    .slice(1)
    .map((row) => {
      const staffId = row[0];
      if (Number.isNaN(Number(staffId)) || staffId === "") return null;

      const rowStaff = newStaff({
        id: staffId,
        name: row[1],
        nameKana: row[2],
        postalCode: row[4],
        address: [row[5], row[6], row[7]].join(" "),
        isSocialInsurance: row[9] === "加入済",
        nearestStation: row[8],
        isActive: row[10] !== "退職",
        createdAt: new Date(),
        updatedAt: new Date(),
      });

      status[staffId] = rowStatus(rowStaff, existingStaffs)[staffId];

      return rowStaff;
    })
    .filter((staff) => staff != null);

  return { staffs, status };
};

export const staffParser = {
  validateCSV,
  parse,
};
